import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppContext from "../../AppContext";
import ContentLoader from "react-content-loader";

import useWorks from "../../hooks/useWorks";
import useUsers from "../../hooks/useUsers";
import { PAGE_STATE } from "../../constants";
import ProfileContext from "./ProfileContext";
import { useLocation } from "react-router-dom";

const assetsURI = import.meta.env.ASSETS_URI;

const Projects = ({ id }) => {
  const { viewProject } = useContext(AppContext);
  const { queryWorks } = useWorks();
  const { queryUsers } = useUsers();
  const navigate = useNavigate();
  const [projects, setProjects] = useState(undefined);
  const [pageState, setPageState] = useState(PAGE_STATE.LOADING);
  const [metadata, setMetadata] = useState(undefined);
  const { user, company, isCompany } = useContext(ProfileContext);
  const location = useLocation();

  useEffect(() => {
    setPageState(PAGE_STATE.LOADING);

    if ((isCompany && !company) || (!isCompany && !user)) return;

    init();
    return () => {};
  }, [user, company, isCompany]);

  const init = async () => {
    const filter = {
      active: true,
      deleted: false,
    };

    if (isCompany) {
      filter.company = company._id;
    }

    if (!isCompany) {
      filter.createdBy = user._id;
    }

    const _works = await queryWorks(filter, 1, 9, undefined, {
      createdOn: -1,
    });
    setProjects(_works?.data);
    setMetadata(_works?._metadata);
    setPageState(PAGE_STATE.IDLE);
  };

  const handleOnPageChange = (page) => {
    // * setPageState(PAGE_STATE.LOADING);

    queryWorks({ createdBy: { $in: userIds } }, page, 9, undefined, {
      createdOn: -1,
    })
      .then((_works) => {
        setProjects(_works?.data);
        setMetadata(_works?._metadata);
        setPageState(PAGE_STATE.IDLE);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleOnLimitChange = async (limit) => {
    // * handleOnLimitChange
  };

  const handleWorkClick = (id, project) => {
    if (project.designType.work) {
      viewProject(id, location);
    } else if (project.designType.workExchange) {
      navigate(`/work-exchanges/${project._id}`);
    }
  };

  if (pageState !== PAGE_STATE.IDLE) {
    return (
      <div className="profile-content-projects">
        <div className="profile-content-projects-work">
          <ContentLoader width={"100%"} height={"100%"}>
            <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
          </ContentLoader>
        </div>
        <div className="profile-content-projects-work">
          <ContentLoader width={"100%"} height={"100%"}>
            <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
          </ContentLoader>
        </div>
        <div className="profile-content-projects-work">
          <ContentLoader width={"100%"} height={"100%"}>
            <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
          </ContentLoader>
        </div>
        <div className="profile-content-projects-work">
          <ContentLoader width={"100%"} height={"100%"}>
            <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
          </ContentLoader>
        </div>
        <div className="profile-content-projects-work">
          <ContentLoader width={"100%"} height={"100%"}>
            <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
          </ContentLoader>
        </div>
        <div className="profile-content-projects-work">
          <ContentLoader width={"100%"} height={"100%"}>
            <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
          </ContentLoader>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="profile-content-projects">
        {projects.map((project) => {
          return (
            <img
              key={project._id}
              className="profile-content-projects-work"
              onClick={() => handleWorkClick(project._id, project)}
              alt="project"
              src={`${assetsURI}/${project.banner}`}
            />
          );
        })}
      </div>
    </>
  );
};

Projects.propTypes = {};

export default Projects;
